import React, {Component} from "react"
import {observer} from "mobx-react"
import WordPress from "./WordPress"
import cmsStore from "stores/cmsStore"

@observer
export default class WordPressContainer extends Component {

  state = {
    slug: "",
    postType: this.props.postType || "page",
    content: {}
  }

  componentWillMount(){
    this.load( this.props.slug )
  }

  load(slug) {
    const { postType } = this.state
    if ( postType === "shop" ) return cmsStore.getModule( slug )
    if ( postType === "page" ) return cmsStore.getPage( slug )

    console.error( `Unknown postType (${postType} for slug ${slug}` )
  }

  render() {
    const {pageBySlug} = cmsStore
    let content = pageBySlug.get( this.props.slug )
    if ( content && content.code ) {
      return <pre>ERROR: {JSON.stringify( content.code, null, 2 )}</pre>
    }
    return (
      <div className="cms-wrapper">
        <WordPress page={content} className={this.props.className} insertAfter={this.props.insertAfter}/>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/WordPressContainer.js